//imports
import React, { Fragment } from "react";
import ProfilePic from "components/General/ProfilePic";
import TextTheme from "components/General/Text/TextTheme";
import "./FriendUserProfileBox.css";
import * as CONSTANT from "constants/text";
import FriendSettingsGear from "site_media/images/settings_gear.png";
import Image from "react-bootstrap/Image";
import ButtonBase from "@material-ui/core/ButtonBase";
import Button from "@material-ui/core/Button";
import CustomDecisionPopup from "components/General/Form/Popup/CustomDecisionPopup";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
/*Friend Request methods*/
import * as FriendRequest from "components/Tribe/Friends/FriendRequestMethods";
/*Group helper methods*/
import * as Groups from "components/Tribe/Groups/GroupHelperMethods.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class FriendUserProfileBox extends React.Component {
  constructor(props) {
    super(props);
    /*Copied from UserStartedProject*/
    // let formattedDate = "";
    // if (this.props.time) {
    //   let event = new Date(this.props.time);
    //   formattedDate = Intl.DateTimeFormat("en-US", {
    //     year: "numeric",
    //     month: "short",
    //     day: "2-digit",
    //   }).format(event);
    // }

    this.state = {
      friendSettingsOpen: false,
      displayWarning: false,
      anchor: "",
      username:this.props.username ? this.props.username.charAt(0).toUpperCase() + this.props.username.slice(1) : this.props.username,
      full_name:this.props.full_name
      // time: formattedDate,
    };

    /*function bindings*/
    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  /*functions to open and close popup*/
  openPopup() {
    this.setState({ displayWarning: true });
  }

  closePopup() {
    this.setState({ displayWarning: false });
  }

  handleFriendSettingsClick(event) {
    if (this.state.friendSettingsOpen) {
      this.setState({ friendSettingsOpen: false });
    } else {
      this.setState({ friendSettingsOpen: true });
    }
  }
  onlyOwnerNotification() {
    toast("You can not leave as you are the only owner of the group!", {
      position: "bottom-right",
      autoClose: 8000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
  editGroupDetails(groupId) {
    window.location.assign("/groups/edit-group-details/" + groupId + "/");
  }
  render() {
    let formattedDate = "";
    if (this.props.time) {
      let event = new Date(this.props.time);
      formattedDate = Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
      }).format(event);
    }
    return (
      <div className="mt-15 profile_info_box mar-b-20">
        <ProfilePic
          profilePic={this.props.profilePic}
          type={this.props.type}
          className="profile_pic_friend"
        />
        <div
          className={
            this.props.type === CONSTANT.GROUPS && this.props.location
              ? "group_profile_detail_rows"
              : "profile_detail_rows"
          }
        >
          <TextTheme
            className="text_medium text_dark_blue text_bold"
            message={this.props.full_name}
          />

          {this.props.type !== CONSTANT.GROUPS ? (
            <TextTheme
              className="text_xsmall text_black"
               message={"Age: " + this.props.age}
            />
          ) : this.props.type === CONSTANT.GROUPS ? (
            this.props.location ? (
              this.props.location
                .split("__")
                .map((string) => (
                  <TextTheme
                    className="text_xsmall text_black"
                    message={string}
                  />
                ))
            ) : null
          ) : null}
          {this.props.type !== CONSTANT.GROUPS ? (
            this.props.location
              .split("__")
              .map((string) => (
                <TextTheme
                  className="text_xsmall text_black"
                  message={string}
                />
              ))
          ) : this.props.type === CONSTANT.GROUPS ? (
            <TextTheme
              className="text_xsmall text_black"
              message={"Started: " + formattedDate}
            />
          ) : null}
        </div>
        {/* If this a friends profile box, display the friends settings. */}
        {this.props.type === CONSTANT.FRIENDS ? (
          <div className="block_user">
            <OverlayTrigger
              trigger={"click"}
              placement="top"
              rootClose={true}
              overlay={
                <Popover>
                  <Popover.Title as="h3">
                    <center>{this.props.full_name}'s settings</center>
                  </Popover.Title>
                  <Popover.Content>
                    <center>
                      <Button
                        size="small"
                        variant="outlined"
                        component="span"
                        style={{
                          textTransform: "None",
                          margin: "0px",
                          border: "0px solid",
                        }}
                        onClick={this.openPopup}
                      >
                        <TextTheme
                          message={CONSTANT.BLOCK}
                          className={
                            "text_xsmall text_bold text_dark_bright_blue"
                          }
                        />
                      </Button>
                      <br />
                    </center>
                  </Popover.Content>
                </Popover>
              }
            >
              <ButtonBase style={{ float: "right", borderRadius: "10px" }}>
                <Image
                  src={FriendSettingsGear}
                  style={{ width: "35px", height: "35px" }}
                />
              </ButtonBase>
            </OverlayTrigger>
            {/* Diplay the popup for blocking*/}
            {this.state.displayWarning ? (
              <CustomDecisionPopup
                popupTitle={CONSTANT.BLOCK + this.props.full_name + "?"}
                popupDescription={
                  CONSTANT.BLOCK_WARNING1 +
                  this.props.full_name +
                  "? " +
                  CONSTANT.BLOCK_WARNING2
                }
                popupDescription2={CONSTANT.BLOCK_WARNING}
                acceptButtonText={CONSTANT.ACCEPT_BLOCK}
                declineButtonText={CONSTANT.DECLINE_BLOCK}
                acceptButtonClick={() =>
                  FriendRequest.block(this.props.username, this.props.blockType)
                }
                declineButtonClick={this.closePopup}
              />
            ) : null}
          </div>
        ) : null}
        {/* If this a group's profile box, display the groups settings. */}
        {this.props.type === CONSTANT.GROUPS ? (
          this.props.isMember ? null : (
            <div className="block_user">
              <OverlayTrigger
                trigger={"click"}
                placement="top"
                rootClose={true}
                overlay={
                  <Popover>
                    <Popover.Title as="h3">
                      <center>{this.props.full_name}'s settings</center>
                    </Popover.Title>
                    <Popover.Content>
                      {this.props.role === "Owner" ? (
                        <center>
                          <Button
                            size="small"
                            variant="outlined"
                            component="span"
                            style={{
                              textTransform: "None",
                              margin: "0px",
                              border: "0px solid",
                            }}
                            onClick={this.editGroupDetails.bind(
                              this,
                              this.props.groupId
                            )}
                          >
                            <TextTheme
                              message="Edit Group Details"
                              className={
                                "text_xsmall text_bold text_dark_bright_blue"
                              }
                            />
                          </Button>
                        </center>
                      ) : null}
                      <center>
                        <Button
                          size="small"
                          variant="outlined"
                          component="span"
                          style={{
                            textTransform: "None",
                            margin: "0px",
                            border: "0px solid",
                          }}
                          onClick={this.openPopup}
                        >
                          <TextTheme
                            message={CONSTANT.LEAVE_GROUP}
                            className={
                              "text_xsmall text_bold text_dark_bright_blue"
                            }
                          />
                        </Button>
                        <br />
                      </center>
                    </Popover.Content>
                  </Popover>
                }
              >
                <ButtonBase style={{ float: "right", borderRadius: "10px" }}>
                  <Image
                    src={FriendSettingsGear}
                    style={{ width: "35px", height: "35px" }}
                  />
                </ButtonBase>
              </OverlayTrigger>
              {/* Diplay the popup for leaving a group */}
              {this.state.displayWarning ? (
                <Fragment>
                  <CustomDecisionPopup
                    popupTitle={CONSTANT.LEAVE + this.props.full_name + "?"}
                    popupDescription={
                      CONSTANT.LEAVE_GROUP_WARNING1 +
                      this.props.full_name +
                      CONSTANT.LEAVE_GROUP_WARNING2
                    }
                    acceptButtonText={
                      CONSTANT.YES_LEAVE_GROUP + this.props.full_name
                    }
                    declineButtonText={CONSTANT.DECLINE_BLOCK}
                    acceptButtonClick={() =>
                      Groups.deleteMembership(
                        this.props.groupId,
                        this.props.groupUser,
                        CONSTANT.LEAVE,
                        this.onlyOwnerNotification.bind(this)
                      )
                    }
                    declineButtonClick={this.closePopup}
                  />
                  <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                  />
                </Fragment>
              ) : null}
            </div>
          )
        ) : null}
      </div>
    );
  }
}

export default FriendUserProfileBox;
